export default function (language, path) {
  return `/${path}/${language}`;
}
